module.exports = require("./classCallCheck.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/helpers/class-call-check.js
 ** module id = 8
 ** module chunks = 0
 **/